// extracted by mini-css-extract-plugin
export default {"paginationItemContanier":"PaginationItem_paginationItemContanier__IQx4V","selected":"PaginationItem_selected__r4lb8"};